import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (!("serviceWorker" in navigator)) return

    navigator.serviceWorker.ready.then((registration) => {
      if (registration.waiting) {
        this._waitingWorker = registration.waiting
        this.bannerTarget.classList.remove("hidden")
      }

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            this._waitingWorker = newWorker
            this.bannerTarget.classList.remove("hidden")
          }
        })
      })
    })
  }

  refresh() {
    if (!this._waitingWorker) return
    this._waitingWorker.postMessage("SKIP_WAITING")
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload()
    })
  }
}
